// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1_B_q","cls2":"MultiPaperModal-cls2__fp MultiPaperModal-cls1_B_q"};